import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import type { Payment } from "~/providers/order-provider";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import PaymentScreen from "./payment";

export default function PaymentDialog({
  payment,
  onClose,
}: {
  payment?: Payment;
  onClose: () => void;
}) {
  const { t } = useTranslation("common");
  return (
    <Dialog
      open={payment !== undefined}
      onOpenChange={(isOpen) => !isOpen && onClose()}
    >
      <DialogContent className="flex flex-col gap-2">
        <DialogHeader>
          <DialogTitle>{t("Checkout.payment_options")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        {payment && (
          <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
            <PaymentScreen onClose={onClose} payment={payment} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
